export interface SquadPreset {
  key: string;
  label: string;
  description: string;
  fanWidth: number;
  pattern: 'P2_call_a_friend' | 'P3_examine_then_dag';
  stances: string[];
  merge: boolean;
}

export const SQUAD_PRESETS: SquadPreset[] = [
  {
    key: 'three_way_review',
    label: '3-way review',
    description: 'Three perspectives merge into synthesis',
    fanWidth: 3,
    pattern: 'P2_call_a_friend',
    stances: ['neutral', 'skeptical', 'allegiant'],
    merge: true,
  },
  {
    key: 'red_team',
    label: 'Red-team panel',
    description: 'All skeptical — stress-test the idea',
    fanWidth: 3,
    pattern: 'P2_call_a_friend',
    stances: ['skeptical', 'skeptical', 'skeptical'],
    merge: true,
  },
  {
    key: 'examine_synthesize',
    label: 'Examine + synthesize',
    description: 'Deep-read sources then merge findings',
    fanWidth: 2,
    pattern: 'P3_examine_then_dag',
    stances: ['neutral', 'neutral'],
    merge: true,
  },
  {
    key: 'fan_out',
    label: 'Fan-out only',
    description: 'Parallel takes — no merge',
    fanWidth: 3,
    pattern: 'P2_call_a_friend',
    stances: ['neutral', 'neutral', 'neutral'],
    merge: false,
  },
];
